<template>
  <div class="box">
    <div class="showPhoto">
      <img class="gif" src="../../../assets/images/car.gif" />
      <div class="lu" @click="loadImg('lu')"></div>
      <div class="ru" @click="loadImg('ru')"></div>
      <div class="ld" @click="loadImg('ld')"></div>
      <div class="rd" @click="loadImg('rd')"></div>
    </div>
    <div class="tip">
      *申请使用轮胎保障尊享服务，须至少上传4张轮胎相关照片(里程数、DOT、鼓包、花纹)，待经销商核实后，确认补偿。
    </div>
    <div class="bottom">
      <p class="title">上传图片展示</p>
      <div class=" tyre-pictures">
        <div class="image-wrapper" v-for="(item, index) in imgArr" :key="index">
          <div class="image-cover" v-if="item.localData" :style="{ backgroundImage: `url(${item.localData})` }"></div>
          <div v-else class="photo fc" @click="showTip">
            <van-icon size="50px" name="photo-o" />
          </div>
          <div v-if="item.position.value" class="tag">
            <div>{{ item.position.tag }}</div>
          </div>
          <div class="action" v-if="item.serverId !== null" @click="deletePicture(index)">
            <div class="delete"><div class="icon"></div></div>
          </div>
        </div>
      </div>
      <div class="description fc" @click="showCount += 1"><van-icon name="description" />&nbsp;轮胎拍照范本</div>

      <van-button @click="submit" type="primary" block class="btn">提交</van-button>
    </div>
    <PopUp :showPopUp="showCount" :datas="img" />
  </div>
</template>

<script>
import { setSession } from '@/util'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { reactive, toRefs, onMounted, computed, onBeforeUnmount } from 'vue'
import { Dialog } from 'vant'
import PopUp from '@/components/common/PopUp'
import { chooseImage, getLocalImgData, wxUploadImage } from '@/api/wx'
import { uploadTyreImage, deleteTyreImage } from '@/api/tyre.js'
import '@/assets/css/common.scss'

export default {
  components: {
    PopUp
  },
  setup() {
    let route = useRoute()
    let store = useStore()
    let router = useRouter()
    let src = require(`@/assets/images/tyreExample.png`)
    const state = reactive({
      showCount: 0,
      imgArr: [],
      deleteIndex: null,
      deletePopupVisible: false,
      img: {
        title: '轮胎照片示例',
        content: `<div style="font-size: 12px;text-align:center;color: #666666;">请尽可能将照片拍摄清晰</div><img style="width:100%;margin:22px 0;" src=${src}>`
      },
      max: 8,
      picturePointer: 0,
      restLen: 8,
      pictureLimitConfirmVisible: false,
      picturePosition: {
        lu: {
          value: 1,
          tag: '左前轮'
        },
        ru: {
          value: 2,
          tag: '右前轮'
        },
        ld: {
          value: 3,
          tag: '左后轮'
        },
        rd: {
          value: 4,
          tag: '右后轮'
        }
      },
      currentPosition: '',
      getEmptyPicture: {
        position: {
          value: null,
          tag: null
        },
        localData: null,
        serverId: null
      }
    })
    let currentPicture = computed(() => {
      return state.imgArr[state.picturePointer]
    })
    const getPicturesKey = () => {
      if (route.query.orderId) {
        return `${route.query.mbpn}-${route.query.orderId}`
      }
      return route.query.mbpn
    }

    const showTip = () => {
      Dialog.alert({
        title: '温馨提示',
        message: '为了确保您所选的轮胎型号适配您的车型，建议您上传轮胎照片，以供后台人工核实。',
        confirmButtonText: '知道了',
        closeOnClickOverlay: true
      })
    }
    const deletePicture = async index => {
      let serverId = state.imgArr[index].serverId
      await deleteTyreImage({ serverId: serverId })
      state.imgArr.splice(index, 1)
      state.imgArr.push(state.getEmptyPicture)
      saveAllPictures()
      state.picturePointer -= 1
    }
    const loadImg = async p => {
      if (state.picturePointer >= state.max) {
        state.pictureLimitConfirmVisible = true
        return
      }
      state.restLen = state.max - state.picturePointer
      let data = await chooseImage(state.restLen)
      state.currentPosition = state.picturePosition[p]
      chooseImageSuccessCallback(data)
    }

    const chooseImageSuccessCallback = async res => {
      let i = 0
      let count = res.localIds.length
      let success = (serverId, localId) => {
        i++
        uploadServerId(serverId, localId)
        if (i < count) {
          upload()
        }
      }

      let failed = () => {
        i++
        if (i < count) {
          upload()
        }
      }

      let upload = async () => {
        let localId = res.localIds[i]
        if (window.__wxjs_is_wkwebview) {
          try {
            let { serverId, localData } = await getLocalImgData(localId)
            success(serverId, localData)
          } catch (e) {
            failed(e)
          }
        } else {
          // android 可直接显示localId 不需要getLocalImgData
          try {
            let serverId = await wxUploadImage(localId)
            success(serverId, localId)
          } catch (e) {
            failed(e)
          }
        }
      }
      upload()
    }
    const uploadServerId = async (serverId, localData) => {
      let res = await uploadTyreImage({
        position: state.currentPosition.value,
        serverId: serverId,
        order: route.query.orderId
      })
      // state.imgArr[state.picturePointer] = {
      //   position: state.currentPosition,
      //   serverId: serverId,
      //   localData: localData,
      //   id: res.id
      // };
      // state.imgArr = [...state.imgArr]; //???
      state.imgArr.splice(state.picturePointer, 1, {
        position: state.currentPosition,
        serverId: serverId,
        localData: localData,
        id: res.id
      })
      // saveAllPictures()
      state.picturePointer += 1
      console.log(state.imgArr)
    }
    const saveAllPictures = () => {
      store.commit('SETTYREPICTURES', {
        key: getPicturesKey(),
        value: state.imgArr.filter(picture => picture.serverId !== null)
      })
    }
    const submit = () => {
      saveAllPictures()
      router.go(-1)
    }
    onBeforeUnmount(() => {
      setSession('fromAddImage', true)
    })
    onMounted(() => {
      state.len = 8 - state.imgArr.length
      let imgArr = []
      store.getters.orderPicture(getPicturesKey()).forEach(element => {
        imgArr.push(element)
      })
      let emptyCount = state.max - imgArr.length
      let picturePointer = imgArr.length
      for (let i = 0; i < emptyCount; i++) {
        imgArr.push(state.getEmptyPicture)
      }
      state.imgArr = imgArr
      state.picturePointer = picturePointer
    })
    return {
      ...toRefs(state),
      showTip,
      loadImg,
      chooseImage,
      currentPicture,
      getPicturesKey,
      deletePicture,
      submit
    }
  }
}
</script>

<style lang="scss" scoped>
.tyre-pictures {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: 9px;
  // .image-wrapper {
  //   width: 21.6vw;
  //   height: 21.6vw;
  //   margin-bottom: 1.8667vw;
  //   border-radius: 3px;
  //   // background-color: #1c2037;
  //   display: flex;
  //   justify-content: center;
  //   align-items: center;
  //   overflow: hidden;
  //   position: relative;

  //   .image-cover {
  //     background-repeat: no-repeat;
  //     background-size: cover;
  //     width: 100%;
  //     height: 100%;
  //   }

  //   .image {
  //     display: flex;
  //     justify-content: center;
  //     align-items: center;
  //     max-width: 100%;

  //     img {
  //       max-width: 100%;
  //     }
  //   }
  //   .action {
  //     position: absolute;
  //     right: 0;
  //     top: 0;
  //     height: 20px;
  //     width: 20px;
  //     display: flex;
  //     justify-content: center;
  //     align-items: center;

  //     .delete {
  //       background-color: #408aed;
  //       height: 12px;
  //       width: 12px;
  //       border-radius: 50%;
  //       display: flex;
  //       justify-content: center;
  //       align-items: center;

  //       .icon {
  //         height: 1px;
  //         width: 7px;
  //         background-color: #212640;
  //       }
  //     }
  //   }
  //   .tag {
  //     position: absolute;
  //     left: -5px;
  //     top: -1px;
  //     width: 33px;
  //     height: 33px;

  //     div {
  //       background: #404963;
  //       font-size: 8px;
  //       transform: rotate(-45deg) translateX(-9px);
  //       width: 45px;
  //       color: white;
  //       text-align: center;
  //     }
  //   }
  // }
}

.box {
  padding-top: 30px;
  background: #fff;
  text-align: left;
}
.gif {
  width: 100%;
}
.bottom,
.tip {
  padding: 24px 20px;
  box-sizing: border-box;
}
.title {
  font-size: 14px;
  color: #333333;
  margin-bottom: 12px;
}
// .fvlrw {
//   img,
.photo {
  width: 80px;
  height: 80px;
  font-size: 50px;
  background: #f8f8f8;
  margin-bottom: 5px;
}
// }
.imgBox {
  position: relative;
  overflow: hidden;
}
.showPhoto {
  position: relative;
  div {
    position: absolute;
    width: 120px;
    height: 40px;
  }
  .lu {
    top: 25px;
    left: 30px;
  }
  .ru {
    top: 25px;
    right: 30px;
  }
  .ld {
    top: 150px;
    left: 30px;
  }
  .rd {
    top: 150px;
    right: 30px;
  }
}
.tip {
  font-size: 12px;
  color: #666666;
  padding-bottom: 0;
}
.description {
  font-size: 14px;
  color: #999999;
  height: 32px;
  border: 1px solid #cccccc;
  margin: 12px auto 16px;
}
</style>
